import { useState } from 'react';
import { post } from '../lib/api';
import type { SessionState } from '../lib/types';
import { Device, Notice, Spinner } from './Device';

export function Login({ state, onRefresh }: { state: SessionState; onRefresh: () => Promise<void> }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await post('/auth/login', { password });
      await onRefresh();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Accesso negato.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Device>
      <div className="login-panel">
        <div className="boot-mark" aria-hidden="true">⌬</div>
        <p className="terminal-lead">INTERFACCIA SIGILLATA // AUTENTICAZIONE RICHIESTA</p>
        {!state.campaign.initialized && <Notice>ARCHIVIO LORE ASSENTE. ACCESSO CONSENTITO ESCLUSIVAMENTE AL DM.</Notice>}
        <form onSubmit={submit} className="stack">
          <label htmlFor="password">CREDENZIALE</label>
          <input id="password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" autoFocus />
          {error && <Notice kind="error">{error}</Notice>}
          <button className="primary" disabled={busy || !password}>{busy ? <Spinner label="VERIFICA" /> : 'CONNETTI'}</button>
        </form>
      </div>
    </Device>
  );
}

export function ClaimIdentity({ players, onRefresh }: { players: SessionState['availablePlayers']; onRefresh: () => Promise<void> }) {
  const [playerId, setPlayerId] = useState(players[0]?.id ?? '');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  async function claim(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    try {
      await post('/players/claim', { playerId });
      await onRefresh();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Identità non disponibile.');
    } finally { setBusy(false); }
  }
  return (
    <Device>
      <div className="login-panel">
        <p className="terminal-lead">IDENTIFICAZIONE OPERATORE</p>
        {players.length ? (
          <form onSubmit={claim} className="stack">
            <label htmlFor="identity">SELEZIONA IDENTITÀ</label>
            <select id="identity" value={playerId} onChange={(event) => setPlayerId(event.target.value)}>
              {players.map((player) => <option key={player.id} value={player.id}>{player.name}</option>)}
            </select>
            {error && <Notice kind="error">{error}</Notice>}
            <button className="primary" disabled={busy || !playerId}>{busy ? 'RECLAMO...' : 'RECLAMA IDENTITÀ'}</button>
          </form>
        ) : <Notice kind="error">NESSUNA IDENTITÀ DISPONIBILE. CONTATTARE IL DM.</Notice>}
      </div>
    </Device>
  );
}
